export const settings = {
  app: {
    name: "DocuTalk",
  },
  // Cookie Names
  cookies: {
    refresh_token: "docutalk_web_refresh_token",
    access_token: "docutalk_web_access_token",
    user: "docutalk_web_user",
    organization: "docutalk_web_organization",
  },
  // API Endpoints
  api: {
    base: import.meta.env.VITE_API_URL || "http://localhost:5001",
    auth: {
      login: "/api/auth/login",
      logout: "/api/auth/logout",
      check: "/api/auth/check",
      refresh: "/api/auth/refresh",
    },
    admin: {
      organizations: "/api/admin/organizations",
      users: "/api/admin/users",
    },
    tariffs: "/api/tariffs",
  },
};
